<template>
  <span
    v-if="status"
    class="zp-status"
    :class="statusClass"
  >{{ humanizedStatus }}</span>
</template>

<script>
// ZetaPilot status readout — cockpit instrument label rather than a Material
// chip. Composition: 8px square indicator + label in small caps. Running
// state pulses; reduced-motion is honoured in the global stylesheet.
const TaskStatus = Object.freeze({
  WAITING: 'waiting',
  STARTING: 'starting',
  WAITING_CONFIRMATION: 'waiting_confirmation',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
  RUNNING: 'running',
  SUCCESS: 'success',
  ERROR: 'error',
  STOPPING: 'stopping',
  STOPPED: 'stopped',
});

const STATUS_VARIANT = {
  [TaskStatus.WAITING]: 'neutral',
  [TaskStatus.STARTING]: 'warning',
  [TaskStatus.RUNNING]: 'running',
  [TaskStatus.SUCCESS]: 'success',
  [TaskStatus.CONFIRMED]: 'success',
  [TaskStatus.ERROR]: 'danger',
  [TaskStatus.REJECTED]: 'danger',
  [TaskStatus.STOPPING]: 'neutral',
  [TaskStatus.STOPPED]: 'neutral',
  [TaskStatus.WAITING_CONFIRMATION]: 'warning',
};

const STATUS_I18N_KEY = {
  [TaskStatus.WAITING]: 'statusQueued',
  [TaskStatus.STARTING]: 'statusStarting',
  [TaskStatus.RUNNING]: 'statusRunning',
  [TaskStatus.SUCCESS]: 'statusOk',
  [TaskStatus.CONFIRMED]: 'statusConfirmed',
  [TaskStatus.ERROR]: 'statusFailed',
  [TaskStatus.REJECTED]: 'statusRejected',
  [TaskStatus.STOPPING]: 'statusStopping',
  [TaskStatus.STOPPED]: 'statusStopped',
  [TaskStatus.WAITING_CONFIRMATION]: 'statusHold',
};

export default {
  props: {
    status: String,
  },

  computed: {
    statusClass() {
      return `zp-status--${STATUS_VARIANT[this.status] || 'neutral'}`;
    },
    humanizedStatus() {
      const key = STATUS_I18N_KEY[this.status];
      return key ? this.$t(key) : this.status;
    },
  },
};
</script>
